import React, { Component } from "react";
import { Dropdown, DropdownButton, Image } from "react-bootstrap";
// import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter, Link } from "react-router-dom";
import { logOutUser } from "../../../store/actions/authAction";
import { get_all_notifications } from "../../../store/actions/notificationActions";
import { get_pending_diner } from "../../../store/actions/dashboardAction/addingAction";
//import VendorEditProfileNavigation from "../editProfileScreen/VendorEditProfileNavigation";
import isEmpty from "../../../store/validation/is-Empty";
import SVG from "react-inlinesvg";
import { Scrollbars } from "react-custom-scrollbars";
import ChatNavigation from "./ChatNavigation";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { VENDOR_SCREEN_ID } from "../../../enums/RoleEnum";
import { IconAndTitleLeftNav } from "./UtilitiesLeftNav";
import QrScanGlobal from "../../reusableComponents/QrScanGlobal/QrScanGlobal";

export class LeftSideNavigation extends Component {
  constructor(props) {
    super();
    this.state = {
      pathname: "",
      errors: {},
      vendor: false,

      offerManagmentDisplay: false,
      scanAndPayDisplay: false,
      eventManagmentDisplay: false,
      experienceManagmentDisplay: false,
      liveStreamingDisplay: false,
      seatingManagementDisplay: false,
      orderingManagementDisplay: false,
      menuSetupDisplay: false,
      notificationsCount: 0,
    };
  }
  componentDidMount() {
    let location = this.props.history && this.props.history.location;
    if (location && !this.state.hasSetUpdate) {
      this.setState({
        pathname: location.pathname,
        hasSetUpdate: true,
      });
      /*************************************
       * @DESC Offer Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.offer_management?.value) ||
        (this.props.fastFoodDiningService &&
          this.props.fastFoodDiningData?.offer_management?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.offer_management?.value)
      ) {
        this.setState({
          offerManagmentDisplay: true,
        });
      }
      /*************************************
       * @DESC Scan And Pay Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.scan_and_pay?.value) ||
        (this.props.fastFoodDiningService &&
          this.props.fastFoodDiningData?.scan_and_pay?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.scan_and_pay?.value)
      ) {
        this.setState({
          scanAndPayDisplay: true,
        });
      }
      /*************************************
       * @DESC Event Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.event_management?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.event_management?.value)
      ) {
        this.setState({
          eventManagmentDisplay: true,
        });
      }

      /*************************************
       * @DESC Experience Management
       **************************************/
      if (
        this.props?.casualDiningData?.experience_management?.value ||
        this.props?.fastFoodDiningService?.experience_management?.value ||
        this.props?.multiDiningData?.experience_management?.value
        // (this.props?.casualDiningData?.experience_management?.value && this.props?.casualDiningData?.experience_management?.offline_experience?.bank_account?.value) ||
        // (this.props?.fastFoodDiningService?.experience_management?.value && this.props?.fastFoodDiningService?.experience_management?.offline_experience?.bank_account?.value) ||
        // (this.props?.multiDiningData?.experience_management?.value && this.props?.multiDiningData?.experience_management?.offline_experience?.bank_account?.value)
      ) {
        this.setState({
          experienceManagmentDisplay: true,
        });
      }

      /*************************************
       * @DESC live Streaming Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.live_streaming?.value) ||
        (this.props.fastFoodDiningService &&
          this.props.fastFoodDiningData?.live_streaming?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.live_streaming?.value)
      ) {
        this.setState({
          liveStreamingDisplay: true,
        });
      }
      /*************************************
       * @DESC Seating Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.seating?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.seating?.value)
      ) {
        this.setState({
          seatingManagementDisplay: true,
        });
      }
      /*************************************
       * @DESC Ordering Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.ordering?.value) ||
        (this.props.fastFoodDiningService &&
          this.props.fastFoodDiningData?.ordering?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.ordering?.value)
      ) {
        this.setState({
          orderingManagementDisplay: true,
        });
      }
      /*************************************
       * @DESC Menu Setup Management
       **************************************/
      if (
        (this.props.casualDiningService &&
          this.props.casualDiningData?.menu_setup?.value) ||
        (this.props.fastFoodDiningService &&
          this.props.fastFoodDiningData?.menu_setup?.value) ||
        (this.props.multiDiningService &&
          this.props.multiDiningData?.menu_setup?.value)
      ) {
        this.setState({
          menuSetupDisplay: true,
        });
      }
    }
    if (this.props.auth) {
      this.setState({
        vendor:
          this.props.auth?.user?.VendorUser?.role === "vendor" ? true : false,
      });
    }
    if (
      this.props.history &&
      this.props.history.location.pathname &&
      this.props.history.location.pathname === "/seatingdashboard" &&
      this.props.history.location.pathname &&
      this.props.history.location.pathname === "/pendingdashboard"
    ) {
      this.props.get_pending_diner(
        this.props.auth.user.VendorUser._id,
        this.props.auth.user.accessToken
      );
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(
        nextProps.history &&
          nextProps.history.location &&
          nextProps.history.location.pathname
      ) !== nextState.pathname ||
      !nextState.hasSetDataUpdate
    ) {
      return {
        notificationsCount: !isEmpty(nextProps?.auth?.notificationsCount)
          ? nextProps?.auth?.notificationsCount?.total_count
          : 0,
        pathname:
          nextProps.history &&
          nextProps.history.location &&
          nextProps.history.location.pathname,
        /*************************************
         * @DESC Offer Management
         **************************************/
        offerManagmentDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.offer_management?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.offer_management?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.offer_management?.value)
            ? true
            : false,
        /*************************************
         * @DESC Scan And Pay Management
         **************************************/
        scanAndPayDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.scan_and_pay?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.scan_and_pay?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.scan_and_pay?.value)
            ? true
            : false,

        /*************************************
         * @DESC Event Management
         **************************************/
        eventManagmentDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.event_management?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.event_management?.value)
            ? true
            : false,

        /*************************************
         * @DESC Experience Management
         **************************************/
        experienceManagmentDisplay:
          nextProps?.casualDiningData?.experience_management?.value ||
          nextProps?.fastFoodDiningData?.experience_management?.value ||
          nextProps?.multiDiningData?.experience_management?.value
            ? // (nextProps?.casualDiningData?.experience_management?.value &&
              //   nextProps?.casualDiningData?.experience_management
              //     ?.offline_experience?.bank_account?.value) ||
              // (nextProps?.fastFoodDiningData?.experience_management?.value &&
              //   nextProps?.fastFoodDiningData?.experience_management
              //     ?.offline_experience?.bank_account?.value) ||
              // (nextProps?.multiDiningData?.experience_management?.value &&
              //   nextProps?.multiDiningData?.experience_management
              //     ?.offline_experience?.bank_account?.value)
              true
            : false,

        /*************************************
         * @DESC live Streaming Management
         **************************************/
        liveStreamingDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.live_streaming?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.live_streaming?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.live_streaming?.value)
            ? true
            : false,

        /*************************************
         * @DESC Seating Management
         **************************************/
        seatingManagementDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.seating?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.seating?.value)
            ? true
            : false,

        /*************************************
         * @DESC Ordering Management
         **************************************/
        orderingManagementDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.ordering?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.ordering?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.ordering?.value)
            ? true
            : false,

        /*************************************
         * @DESC Menu Setup Management
         **************************************/
        menuSetupDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.menu_setup?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.menu_setup?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.menu_setup?.value)
            ? true
            : false,
        hasSetDataUpdate: true,
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let location = prevProps?.history && prevProps?.history?.location;
    if (location && !this.state?.hasSetUpdate) {
      this.setState({
        pathname: location?.pathname,
        hasSetUpdate: true,
      });
    }
  }

  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logOutUser();
  };

  render() {
    try {
      let pendingRecords = !isEmpty(this.props.allPendingDetails)
        ? this.props.allPendingDetails
        : [];
      let pending = !isEmpty(
        this.props.notification && this.props.notification.get_all_notifications
      )
        ? this.props.notification.get_all_notifications
        : [];
      // let reservation = !isEmpty(
      //   this.props.notification && this.props.notification.reservation
      // )
      //   ? this.props.notification.reservation
      //   : [];
      // let walkin = !isEmpty(
      //   this.props.notification && this.props.notification.walkins
      // )
      //   ? this.props.notification.walkins
      //   : [];
      let totalUnreadCount = pending;
      // .concat(reservation).concat(walkin);
      totalUnreadCount = totalUnreadCount.filter(
        (data) => data.readStatus === false
      ).length;

      const { pathname } = this.state;
      // console.log(pathname);
      return (
        <React.Fragment>
          <div className="left-side-navigation" style={{overflowX:'hidden'}}>
            <NavLink to="/customerbusiness" title="Amealio" className="enLogo">
              <Image
                src={require("../../../assets/images/logo.png")}
                className="img-fluid"
                alt="Amealio Logo"
                style={{ marginLeft: "-15px" }}
              />
            </NavLink>
            {this.props.displayLink === 1 ? (
              <Scrollbars
                style={{
                  width: "100%",
                  height: "calc(100vh - 150px)",
                  overflowX:"hidden"
                }}
              >
                <ul type="none" className="navigation-order-list">
                  <li
                    className={`${
                      (pathname && pathname === "/superadminallusers") ||
                      (pathname && pathname === "/openissuesusers") ||
                      (pathname && pathname === "/superadminuserfavorite") ||
                      (pathname &&
                        pathname === "/superadminuserviewactivity") ||
                      (pathname && pathname === "/closewallet") ||
                      (pathname && pathname === "/adduser")
                        ? "selected"
                        : ""
                    }`}
                  >
                    {[1, 2, 3, 5, 7].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/user.svg")}
                            title={
                              <>
                                User <br />
                                Management
                              </>
                            }
                          />
                          // <div className="ml-2">
                          //   <SVG
                          //     src={require("../../../assets/images/Menu/user.svg")}
                          //     className="navigation-icon"
                          //     alt="Icon"
                          //   />
                          //   <div
                          //     style={{
                          //       color: "white",
                          //       position: "relative",
                          //       zIndex: "9",
                          //     }}
                          //     class="f9-400 text-left-navigation-main-title"
                          //   >
                          //     User <br />
                          //     Management
                          //   </div>
                          // </div>
                        }
                      >
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/superadminallusers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/superadminallusers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/userMenu/1.svg")}
                              alt="Icon"
                            />
                            User
                            <br /> Management
                          </Dropdown.Item>
                        )}
                        {[1, 2, 5, 7].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/openissuesusers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/openissuesusers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/userMenu/2.svg")}
                              alt="Icon"
                            />
                            Open Tickets
                            <br />
                            (User)
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/superadminuserfavorite"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/superadminuserfavorite"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/userMenu/3.svg")}
                              alt="Icon"
                            />
                            User
                            <br />
                            Favourites
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/superadminuserviewactivity"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname === "/superadminuserviewactivity"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/userMenu/4.svg")}
                              alt="Icon"
                            />
                            User View/
                            <br />
                            Used Activity
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/closewallet"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/closewallet"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                              alt="Icon"
                            />
                            Close Wallet <br /> Requests
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/deleteUsers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/deleteUsers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                              alt="Icon"
                            />
                            Delete Users <br /> Requests
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/retainedUsers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/returnUsers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                              alt="Icon"
                            />
                            Return Users <br /> Requests
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/adduser"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/adduser"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/userMenu/5.svg")}
                              alt="Icon"
                            />
                            Add User
                          </Dropdown.Item>
                        )}
                      </DropdownButton>
                    )}
                  </li>
                  {/* <li
                    className={`${(pathname && pathname === "/superadminallvendors") ||
                      (pathname &&
                        pathname === "/superadminallpendingvendors") ||
                      (pathname && pathname === "/openissuesvendors")
                      ? "selected"
                      : ""
                      }`}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                        <DropdownButton
                          key={"right"}
                          id={`dropdown-button-drop-right`}
                          drop={"right"}
                          variant="link"
                          title={
                            <IconAndTitleLeftNav
                              icon={require("../../../assets/images/Menu/vendor.svg")}
                              title={
                                <>
                                  Merchant <br />
                                  Management
                                </>
                              }
                            />

                            // <SVG
                            //   src={require("../../../assets/images/Menu/vendor.svg")}
                            //   className="navigation-icon"
                            //   alt="Vendor Icon"
                            // />
                          }
                        >
                          {[1, 2, 3, 5, 6, 7, 8, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                              <Dropdown.Item
                                as={Link}
                                to="/superadminallvendors"
                                className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${pathname && pathname === "/superadminallvendors"
                                  ? "selected"
                                  : ""
                                  }`}
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                  alt="Icon"
                                />
                                All Active
                                <br />
                                Vendors
                              </Dropdown.Item>
                            )}
                          {[1, 2, 3, 4].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                              <>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadminallpendingvendors"
                                  className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${pathname &&
                                    pathname === "/superadminallpendingvendors"
                                    ? "selected"
                                    : ""
                                    }`}
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/2.svg")}
                                    alt="Icon"
                                  />
                                  Pending
                                  <br />
                                  Vendors
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/openissuesvendors"
                                  className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${pathname && pathname === "/openissuesvendors"
                                    ? "selected"
                                    : ""
                                    }`}
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/3.svg")}
                                    alt="Icon"
                                  />
                                  Open Issues & <br /> Suggestions <br />
                                  (Vendors)
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/addvendor"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/4.svg")}
                                    alt="Icon"
                                  />
                                  Add Vendor
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin-pending-chains-vendor"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/2.svg")}
                                    alt="Icon"
                                  />
                                  Pending Chain <br />
                                  Vendor Req.
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin-active-chains-vendor"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Active Chain <br />
                                  Vendor Req.
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin/merchant-promotions"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Merchant <br />
                                  Promotion
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin/merchant-maintain-tags"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Maintain <br />
                                  Merchant Tags
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin/merchant-validate-tags"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Validate <br />
                                  Merchant Tags
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/superadmin/merchant-approve-tags"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Approve <br />
                                  Merchant Tags
                                </Dropdown.Item>
                              </>
                            )}
                        </DropdownButton>
                      )}
                  </li>
                  <li
                    className={`${pathname &&
                      pathname === "/superadminseatingpendingactivityreport"
                      ? "selected"
                      : ""
                      }`}
                  >
                    {[1, 2, 3, 5, 7, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                        <DropdownButton
                          key={"right"}
                          id={`dropdown-button-drop-right`}
                          drop={"right"}
                          variant="link"
                          title={
                            <IconAndTitleLeftNav
                              icon={require("../../../assets/images/Menu/seating.svg")}
                              title={
                                <>
                                  Seating <br />
                                  Dashboard
                                </>
                              }
                            />

                            // <SVG
                            //   src={require("../../../assets/images/Menu/seating.svg")}
                            //   className="navigation-icon"
                            //   alt="Seating Icon"
                            // />
                          }
                        >
                          <Dropdown.Item
                            as={Link}
                            to="/superadminseatingpendingactivityreport"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/seatingMenu/seating (3).svg")}
                              alt="Icon"
                            />
                            Pending
                            <br />
                            Activity Report
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminseatingactivityreport"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/seatingMenu/seating (3).svg")}
                              alt="Icon"
                            />
                            Seating
                            <br /> Activity Report
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminseatingall"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/seatingMenu/seating (1).svg")}
                              alt="Icon"
                            />
                            All Seating
                            <br /> Dashboard
                          </Dropdown.Item>
                      </DropdownButton>
                    )}
                  </li> */}
                  <li
                    className={`${
                      (pathname && pathname === "/superadminallvendors") ||
                      (pathname &&
                        pathname === "/superadminallpendingvendors") ||
                      (pathname && pathname === "/openissuesvendors") ||
                      (pathname && pathname === "/addvendor") ||
                      (pathname &&
                        pathname === "/superadmin-pending-chains-vendor") ||
                      (pathname &&
                        pathname === "/superadmin-active-chains-vendor") ||
                      (pathname &&
                        pathname === "/superadmin/merchant-promotions") ||
                      (pathname &&
                        pathname === "/superadmin/merchant-maintain-tags") ||
                      (pathname &&
                        pathname === "/superadmin/merchant-validate-tags") ||
                      (pathname &&
                        pathname === "/superadmin/merchant-approve-tags")
                        ? "selected"
                        : ""
                    }`}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/vendor.svg")}
                            title={
                              <>
                                Merchant <br />
                                Management
                              </>
                            }
                          />

                          // <SVG
                          //   src={require("../../../assets/images/Menu/vendor.svg")}
                          //   className="navigation-icon"
                          //   alt="Vendor Icon"
                          // />
                        }
                      >
                        {[1, 2, 3, 5, 6, 7, 8, 12].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <Dropdown.Item
                            as={Link}
                            to="/superadminallvendors"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/superadminallvendors"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                              alt="Icon"
                            />
                            All Active
                            <br />
                            Vendors
                          </Dropdown.Item>
                        )}
                        {[1, 2, 3, 4].includes(
                          this.props.auth.user.VendorUser.permission
                        ) && (
                          <>
                            <Dropdown.Item
                              as={Link}
                              to="/superadminallpendingvendors"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/superadminallpendingvendors"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/2.svg")}
                                alt="Icon"
                              />
                              Pending
                              <br />
                              Vendors
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/openissuesvendors"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/openissuesvendors"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/3.svg")}
                                alt="Icon"
                              />
                              Open Issues & <br /> Suggestions <br />
                              (Vendors)
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/addvendor"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/addvendor"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/4.svg")}
                                alt="Icon"
                              />
                              Add Vendor
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin-pending-chains-vendor"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/superadmin-pending-chains-vendor"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/2.svg")}
                                alt="Icon"
                              />
                              Pending Chain <br />
                              Vendor Req.
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin-active-chains-vendor"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/superadmin-active-chains-vendor"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                alt="Icon"
                              />
                              Active Chain <br />
                              Vendor Req.
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin/merchant-promotions"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/superadmin/merchant-promotions"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                alt="Icon"
                              />
                              Merchant <br />
                              Promotion
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin/merchant-maintain-tags"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname ===
                                  "/superadmin/merchant-maintain-tags"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                alt="Icon"
                              />
                              Maintain <br />
                              Merchant Tags
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin/merchant-validate-tags"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname ===
                                  "/superadmin/merchant-validate-tags"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                alt="Icon"
                              />
                              Validate <br />
                              Merchant Tags
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin/merchant-approve-tags"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/superadmin/merchant-approve-tags"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vendorMenu/1.svg")}
                                alt="Icon"
                              />
                              Approve <br />
                              Merchant Tags
                            </Dropdown.Item>
                          </>
                        )}
                      </DropdownButton>
                    )}
                  </li>
                  <li
                    className={`${
                      (pathname &&
                        pathname ===
                          "/superadminseatingpendingactivityreport") ||
                      (pathname &&
                        pathname === "/superadminseatingactivityreport") ||
                      (pathname && pathname === "/superadminseatingall")
                        ? "selected"
                        : ""
                    }`}
                  >
                    {[1, 2, 3, 5, 7, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/seating.svg")}
                            title={
                              <>
                                Seating <br />
                                Dashboard
                              </>
                            }
                          />

                          // <SVG
                          //   src={require("../../../assets/images/Menu/seating.svg")}
                          //   className="navigation-icon"
                          //   alt="Seating Icon"
                          // />
                        }
                      >
                        <Dropdown.Item
                          as={Link}
                          to="/superadminseatingpendingactivityreport"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadminseatingpendingactivityreport"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/seatingMenu/seating (3).svg")}
                            alt="Icon"
                          />
                          Pending
                          <br />
                          Activity Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadminseatingactivityreport"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadminseatingactivityreport"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/seatingMenu/seating (3).svg")}
                            alt="Icon"
                          />
                          Seating
                          <br /> Activity Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadminseatingall"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminseatingall"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/seatingMenu/seating (1).svg")}
                            alt="Icon"
                          />
                          All Seating
                          <br /> Dashboard
                        </Dropdown.Item>
                        {/* <Dropdown.Item
                      as={Link}
                      to="/superadminvendorseatingsummaryreports"
                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/seatingMenu/seating (2).svg")}
                        alt="Icon"
                      />
                      Vendor Seating
                      <br /> Summary
                      <br /> Reports
                    </Dropdown.Item> */}
                      </DropdownButton>
                    )}
                  </li>
                  <li
                    className={`${
                      pathname && pathname?.includes("experience")
                        ? "selected"
                        : ""
                    }`}
                  >
                    {[1, 2, 3, 5, 7, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/leftNav/event.svg")}
                            title={<>Experience</>}
                          />

                          // <SVG
                          //   src={require("../../../assets/images/Menu/seating.svg")}
                          //   className="navigation-icon"
                          //   alt="Seating Icon"
                          // />
                        }
                      >
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/experience/pages"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadmin/experience/pages"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          Curation Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/experience/reports/activity/pending"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/experience/reports/activity/pending"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          Pending Experience
                          <br /> Activity Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/experience/reports/activity/special"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/experience/reports/activity"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          Special/Curated
                          <br /> Experience Activity
                          <br /> Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/experience/dashboard/all"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadmin/experience/dashboard/all"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          All Experiences
                          <br /> Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/experience/merchant/management"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/experience/merchant/management"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          Merchant Experience
                          <br />
                          Management Dashboard
                        </Dropdown.Item>
                      </DropdownButton>
                    )}
                  </li>
                  <li>
                    {[1, 2].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/report.svg")}
                            title={
                              <>
                                Reports
                                <br />
                              </>
                            }
                          />

                          // <SVG
                          //   src={require("../../../assets/images/Menu/report.svg")}
                          //   className="navigation-icon"
                          //   alt="report Icon"
                          // />
                        }
                      >
                        <div
                          className="w-50"
                          style={{ maxHeight: "100vh", overflowY: "scroll" }}
                        >
                          {[1, 2, 3, 4].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <Dropdown.Item
                              as={Link}
                              to="/superadmin/vendorreports"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                                alt="Icon"
                              />
                              Vendor
                              <br />
                              Reports
                            </Dropdown.Item>
                          )}
                          {[1, 2, 3, 4, 5].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <Dropdown.Item
                              as={Link}
                              to="/"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/reportMenu/2.svg")}
                                alt="Icon"
                              />
                              user
                              <br />
                              Reports
                            </Dropdown.Item>
                          )}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <Dropdown.Item
                              as={Link}
                              to="/menuitemsummaryreport"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                                alt="Icon"
                              />
                              Item
                              <br />
                              Reports
                            </Dropdown.Item>
                          )}
                          <Dropdown.Item
                            as={Link}
                            to="/userRegistrationAmealio"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                              alt="Icon"
                            />
                            user registration
                            <br />
                            Reports Amealio_website
                          </Dropdown.Item>
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              {" "}
                              <h6 className="ml-3">
                                <b>User Analytics</b>
                              </h6>
                              <div className="row">
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/reports/restaurants"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                      alt="Icon"
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                    Restaurant   
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/reports/amealiogeneral"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                      alt="Icon"
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                    Amealio General
                                  </Dropdown.Item>
                                </div>
                               
                              </div>
                            </>
                          )}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && <OrderingReportsSuperAdmin />}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              {" "}
                              <h6 className="ml-3">
                                <b>Seating</b>
                              </h6>
                              <div className="row">
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/allseatingactivityreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                      alt="Icon"
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                    Seating All
                                    <br /> Activity Report
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/seatingpendingreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                      alt="Icon"
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                    Seating Pending
                                    <br /> Activity Report
                                  </Dropdown.Item>
                                </div>
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/seatingsummaryreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                      alt="Icon"
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                    Seating Summary
                                    <br /> Report
                                  </Dropdown.Item>
                                </div>
                              </div>
                            </>
                          )}
                          {[1, 2, 3, 5, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              {" "}
                              <h6 className="ml-3">
                                <b>Experience</b>
                              </h6>
                              <div className="row">
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/experiencesummaryreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/event.svg")}
                                      alt="Icon"
                                    />
                                    Experience <br />
                                    Summary Report
                                  </Dropdown.Item>
                                </div>
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/experienceactivityreport"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/event.svg")}
                                      alt="Icon"
                                    />
                                    Experience <br />
                                    Activity Report
                                  </Dropdown.Item>
                                </div>
                                <div className="col-12"></div>
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/experiencecancellationreport"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/event.svg")}
                                      alt="Icon"
                                    />
                                    Experience Ticket <br />
                                    Cancellation <br />
                                    Activity Report
                                  </Dropdown.Item>
                                </div>
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/experiencerefundreport"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/event.svg")}
                                      alt="Icon"
                                    />
                                    Refund Report
                                  </Dropdown.Item>
                                </div>
                              </div>
                            </>
                          )}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              {" "}
                              <h6 className="ml-3">
                                <b>Offers</b>
                              </h6>
                              <div className="row">
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/offersactivityreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/tag.svg")}
                                      alt="Icon"
                                    />
                                    Offers Activity
                                    <br /> Report
                                  </Dropdown.Item>
                                </div>
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadmin/offersummaryreports"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/tag.svg")}
                                      alt="Icon"
                                    />
                                    Offers Summary
                                    <br /> Report
                                  </Dropdown.Item>
                                </div>
                              </div>
                            </>
                          )}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              <h6 className="ml-3">
                                <b>Settlements</b>
                              </h6>
                              <div className="row">
                                <div className="col-6">
                                  <Dropdown.Item
                                    as={Link}
                                    to="/superadminsettlementsummaryreport"
                                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                  >
                                    <SVG
                                      src={require("../../../assets/images/leftNav/money.svg")}
                                      alt="Icon"
                                    />
                                    Settlement Summary
                                    <br /> Report
                                  </Dropdown.Item>
                                </div>
                                {/* <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/superadminordersettlementreport"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/report.svg")}
                            alt="Icon"
                          />
                          Settlement Activity
                          <br /> Report
                        </Dropdown.Item>
                      </div> */}
                              </div>
                            </>
                          )}
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <>
                              <Dropdown.Item
                                as={Link}
                                to="/superadmin/scanandpayactivityreport"
                                className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/reportMenu/3.svg")}
                                  alt="Icon"
                                />
                                Scan & Pay
                                <br />
                                Activity Report
                              </Dropdown.Item>
                              <Dropdown.Item
                                as={Link}
                                to="/superadmin/scanandpaysummaryreport"
                                className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                                  alt="Icon"
                                />
                                Scan & Pay
                                <br />
                                Summary Report
                              </Dropdown.Item>
                            </>
                          )}
                          <h6 className="ml-3">
                            <b>Sales</b>
                          </h6>
                          {[1, 2, 3, 5, 6, 7, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <Dropdown.Item
                              as={Link}
                              to="/superadmininvoice"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/reportMenu/5.svg")}
                                alt="Icon"
                              />
                              Invoice
                              <br />
                              Report
                            </Dropdown.Item>
                          )}
                          {[1, 2, 5, 12].includes(
                            this.props.auth.user.VendorUser.permission
                          ) && (
                            <Dropdown.Item
                              as={Link}
                              to="/superadmindonationreport"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/reportMenu/6.svg")}
                                alt="Icon"
                              />
                              Donation
                              <br />
                              Report
                            </Dropdown.Item>
                          )}
                        </div>
                      </DropdownButton>
                    )}
                  </li>
                  {/* <li className={`${ pathname.includes("/short-videos") ? "selected" : null }`}>
                    {[1, 2].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <NavLink
                        exact
                        to={"/superadmin/short-videos"}
                        title="Short Videos"
                        className="dropdown-toggle btn btn-link"
                      >
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/order.svg")}
                          title={
                            <>
                              Short Videos <br />
                              Dashboard
                            </>
                          }
                        />
                      </NavLink>
                    )}
                  </li> */}
                  <li
                    className={`${
                      (pathname &&
                        pathname === "/superadminpendingordersactivity") ||
                      (pathname && pathname === "/superadminordersactivity") ||
                      (pathname && pathname === "/superadminallorders")
                        ? "selected"
                        : ""
                    }`}
                  >
                    {[1, 2, 3, 5, 7, 12].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/order.svg")}
                            title={
                              <>
                                Ordering
                                <br />
                                Dashboard
                              </>
                            }
                          />
                          // <SVG
                          //   src={require("../../../assets/images/Menu/order.svg")}
                          //   className="navigation-icon"
                          //   alt="order Icon"
                          // />
                        }
                      >
                        <Dropdown.Item
                          as={Link}
                          to="/superadminpendingordersactivity"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadminpendingordersactivity"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/orderMenu/2.svg")}
                            alt="Icon"
                          />
                          Pending Order
                          <br />
                          Activity Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadminordersactivity"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminordersactivity"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/orderMenu/3.svg")}
                            alt="Icon"
                          />
                          All Order
                          <br />
                          Activity Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/superadminallorders"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminallorders"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/orderMenu/1.svg")}
                            alt="Icon"
                          />
                          All Ordering <br /> Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/cancelledorders"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/cancelledorders"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/orderMenu/1.svg")}
                            alt="Icon"
                          />
                          Cancelled Orders
                        </Dropdown.Item>
                      </DropdownButton>
                    )}
                  </li>
                  <li
                    className={`${
                      (pathname && pathname === "/superadminscanpay") ||
                      (pathname &&
                        pathname === "/superadminuserwallattransactions") ||
                      (pathname && pathname === "/superadminscanpay") ||
                      (pathname && pathname.includes("/paymentactivityreports"))
                        ? "selected"
                        : ""
                    }`}
                  >
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/payment.svg")}
                          title={<>Payments</>}
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/payment.svg")}
                        //   className="navigation-icon"
                        //   alt="payment Icon"
                        // />
                      }
                    >
                      {[1, 2].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/paymentactivityreports"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/1.svg")}
                            alt="Icon"
                          />
                          Payment <br />
                          Activity Logs
                        </Dropdown.Item>
                      )}
                      {[1, 2].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminopenitemsettlement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Open Items <br />
                            for Settlement
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin/initiated-settlement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Initiated Settlement Requests
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin/approvedSettlement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Approved Settlement Requests
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/merchant-statement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Merchant Statement
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/resetstatement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Reset to Clear
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/unsetstatement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/paymentMenu/2.svg")}
                              alt="Icon"
                            />
                            Reset to Unclear
                          </Dropdown.Item>
                        </>
                      )}
                      {[1].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminuserwallattransactions"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadminuserwallattransactions"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          User Wallet
                          <br />
                          Transactions
                        </Dropdown.Item>
                      )}
                      {[1, 2].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminscanpay"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminscanpay"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/4.svg")}
                            alt="Icon"
                          />
                          Scan & Pay
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/paymentactivitysummaryreports"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/5.svg")}
                            alt="Icon"
                          />
                          Payment
                          <br />
                          Summary Logs
                        </Dropdown.Item>
                      )}
                      {[1].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/userwallet"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadmin/userwallet"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          User Wallet
                          <br />
                          Administration
                        </Dropdown.Item>
                      )}
                      {[1].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/userwallet/addremovemoneyrequest"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/userwallet/addremovemoneyrequest"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Add/Remove
                          <br />
                          Money Request
                        </Dropdown.Item>
                      )}
                      {[1].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/userwallet/approved-process"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/userwallet/approved-process"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Add/Remove Money
                          <br />
                          Approved Requests
                        </Dropdown.Item>
                      )}
                      {/* <Dropdown.Item
                      as={Link}
                      to="/superadmin/userwallet/allreferrals"
                      className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${pathname &&
                        pathname === "/superadmin/userwallet/allreferrals"
                        ? "selected"
                        : ""
                        }`}
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                        alt="Icon"
                      />
                      User Wallet
                      <br />
                      All Referrals
                    </Dropdown.Item> */}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/userwallet/transfermoneyrequest"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/userwallet/transfermoneyrequest"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Transfer Money
                          <br />
                          Request
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/userwallet/transfermoneyrequest/approved-process"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/userwallet/transfermoneyrequest/approved-process"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Transfer Money
                          <br />
                          Approved Requests
                        </Dropdown.Item>
                      )}

                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/departmentwallet"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadmin/departmentwallet"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Departmental Wallet
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/departmentwallet/addremovemoneyrequest"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/departmentwallet/addremovemoneyrequest"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Departmental Wallet
                          <br />
                          Requests
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/departmentwallet/approved-process"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/departmentwallet/approved-process"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Departmental Wallet
                          <br />
                          Approved Requests
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superadminuserwallattransactions"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                            alt="Icon"
                          />
                          Dispute
                          <br />
                          Management
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        as={Link}
                        to="/"
                        className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                          pathname && pathname === "/superadmindunzostatement"
                            ? "selected"
                            : ""
                        }`}
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/paymentMenu/3.svg")}
                          alt="Icon"
                        />
                        Dunzo
                        <br />
                        statement
                      </Dropdown.Item>
                    </DropdownButton>
                  </li>
                  <li>
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/communication.svg")}
                          title={<>Communication</>}
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/communication.svg")}
                        //   className="navigation-icon"
                        //   alt="communication Icon"
                        // />
                      }
                    >
                      {[1, 5, 7, 9, 10, 11].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminchatmanagement"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/communicationMenu/1.svg")}
                            alt="Icon"
                          />
                          Chat
                        </Dropdown.Item>
                      )}
                      {[1, 5, 7, 9, 10, 11].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-notification-templatemanagement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/communicationMenu/2.svg")}
                              alt="Icon"
                            />
                            Push <br />
                            Notifications
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminemailtemplatemanagement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/communicationMenu/3.svg")}
                              alt="Icon"
                            />
                            Emails
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminsmstemplatemanagement"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/communicationMenu/4.svg")}
                              alt="Icon"
                            />
                            SMS
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminnotifyusers"
                            className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/communicationMenu/5.svg")}
                              alt="Icon"
                            />
                            In App <br />
                            Notification
                          </Dropdown.Item>
                        </>
                      )}
                    </DropdownButton>
                  </li>
                  <li
                    className={`${
                      (pathname && pathname === "/superadminiconlist") ||
                      pathname?.includes("superadmin-chain") ||
                      pathname?.includes("superadmin-global")
                        ? "selected"
                        : ""
                    }`}
                  >
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/menu.svg")}
                          title={
                            <>
                              Global <br />
                              Catalogue
                            </>
                          }
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/menu.svg")}
                        //   className="navigation-icon"
                        //   alt="Icon"
                        // />
                      }
                    >
                      {[1, 2, 3, 4, 5, 8].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <>
                          {" "}
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-global-items-management/item"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname ===
                                "/superadmin-global-items-management/item"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/1.svg")}
                              alt="Icon"
                            />
                            Global Item <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-global-items-management/category"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname ===
                                "/superadmin-global-items-management/category"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/2.svg")}
                              alt="Icon"
                            />
                            Global Category <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-global-items-management/addons"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname ===
                                "/superadmin-global-items-management/addons"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/2.svg")}
                              alt="Icon"
                            />
                            Global Add Ons <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-chain-items-management/item"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray  ${
                              pathname &&
                              pathname ===
                                "/superadmin-chain-items-management/item"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/1.svg")}
                              alt="Icon"
                            />
                            Chain Item <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-chain-items-management/category"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname ===
                                "/superadmin-chain-items-management/category"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/2.svg")}
                              alt="Icon"
                            />
                            Chain Category <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-chain-items-management/addons"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname ===
                                "/superadmin-chain-items-management/addons"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/2.svg")}
                              alt="Icon"
                            />
                            Chain Add Ons <br />
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadmin-global-catalogue"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname === "/superadmin-global-catalogue"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/menuMenu/4.svg")}
                              alt="Icon"
                            />
                            Catalogue
                            <br />
                            Management
                          </Dropdown.Item>
                        </>
                      )}
                      {[1, 2, 9].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminiconlist"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminiconlist"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/menuMenu/5.svg")}
                            alt="Icon"
                          />
                          Categories
                          <br />
                          and Icons
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 4, 5, 8].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/menuMenu/6.svg")}
                            alt="Icon"
                          />
                          Import Bulk
                        </Dropdown.Item>
                      )}
                    </DropdownButton>
                  </li>
                  <li>
                    {[1].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/admin.svg")}
                            title={<>Permissions</>}
                          />
                          // <SVG
                          //   src={require("../../../assets/images/Menu/admin.svg")}
                          //   className="navigation-icon"
                          //   alt="Icon"
                          // />
                        }
                      >
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/adminMenu/1.svg")}
                            alt="Icon"
                          />
                          Admin/
                          <br />
                          Sub Admins
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/adminMenu/2.svg")}
                            alt="Icon"
                          />
                          Permissions
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/adminMenu/3.svg")}
                            alt="Icon"
                          />
                          Add Admin User
                        </Dropdown.Item>
                      </DropdownButton>
                    )}
                  </li>
                  <li
                    className={`${
                      (pathname && pathname === "/superadminiconlist") ||
                      (pathname &&
                        pathname ===
                          "/superadmin/management-services/adduom") ||
                      (pathname &&
                        pathname ===
                          "/superadmin/management-services/addratio") ||
                      (pathname &&
                        pathname ===
                          "/superadmin/management-services/unitofmanagement") ||
                      (pathname &&
                        pathname ===
                          "/superadmin/management-services/uom-ratio") ||
                      (pathname &&
                        pathname === "/adminunitofmanagementratio") ||
                      pathname?.includes("superadmin-chain") ||
                      pathname?.includes("superadmin-global")
                        ? "selected"
                        : ""
                    }`}
                  >
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/data-management.svg")}
                          title={
                            <>
                              Management
                              <br />
                              Section
                            </>
                          }
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/data-management.svg")}
                        //   className="navigation-icon"
                        //   alt="Icon"
                        // />
                      }
                    >
                      {[1, 2, 3, 5, 6, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/management-services/adduom"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/management-services/adduom"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/1.svg")}
                            alt="Icon"
                          />
                          Add UOM
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 5, 6, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/management-services/addratio"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/management-services/addratio"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/2.svg")}
                            alt="Icon"
                          />
                          Add UOM Ratio
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 5, 6, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/management-services/unitofmanagement"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/management-services/unitofmanagement"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/3.svg")}
                            alt="Icon"
                          />
                          Unit Of Measurement
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 5, 6, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/management-services/uom-ratio"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/superadmin/management-services/uom-ratio"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/4.svg")}
                            alt="Icon"
                          />
                          Unit Of Measurement <br /> Ratio
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        as={Link}
                        to="/superadminposdashboard"
                        className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/dataMenu/5.svg")}
                          alt="Icon"
                        />
                        Pos settings
                      </Dropdown.Item>
                      {[1, 2, 3, 4, 5, 8].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/dataMenu/1.svg")}
                            alt="Icon"
                          />
                          Masters
                          <br />
                          (KPIs)
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 7].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminfaqmanagement"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/dataMenu/2.svg")}
                            alt="Icon"
                          />
                          FAQ
                          <br />
                          Management
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 7].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/dataMenu/3.svg")}
                            alt="Icon"
                          />
                          Area
                          <br />
                          Management
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 7].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/dataMenu/4.svg")}
                            alt="Icon"
                          />
                          Help
                          <br />
                          Management
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 7].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/dataMenu/5.svg")}
                            alt="Icon"
                          />
                          Cancel Reasons
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        as={Link}
                        to="/superadmindunzoDeliverySettings"
                        className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/dataMenu/5.svg")}
                          alt="Icon"
                        />
                        Delivery settings
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/superadmindunzostatement"
                        className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/dataMenu/5.svg")}
                          alt="Icon"
                        />
                        Dunzo Statement
                      </Dropdown.Item>
                    </DropdownButton>
                  </li>
                  <li
                    className={
                      (pathname && pathname === "/superadminoffers") ||
                      (pathname && pathname === "/restaurantadminoffers") ||
                      (pathname &&
                        pathname === "/superadminrestaurantevents") ||
                      (pathname && pathname === "/superadminreferralcode") ||
                      (pathname &&
                        pathname === "/superadmin/promotional-videos")
                        ? "selected"
                        : ""
                    }
                  >
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/offer.svg")}
                          title={<>Promotions</>}
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/offer.svg")}
                        //   className="navigation-icon"
                        //   alt="Icon"
                        // />
                      }
                    >
                      {[1, 2, 3, 4, 7, 8, 9, 11].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminoffers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/superadminoffers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/offerMenu/1.svg")}
                              alt="Icon"
                            />
                            Super Admin
                            <br />
                            Offers
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/restaurantadminoffers"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname && pathname === "/restaurantadminoffers"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/offerMenu/2.svg")}
                              alt="Icon"
                            />
                            Restaurant
                            <br />
                            Offers
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to="/superadminrestaurantevents"
                            className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                              pathname &&
                              pathname === "/superadminrestaurantevents"
                                ? "selected"
                                : ""
                            }`}
                          >
                            <SVG
                              src={require("../../../assets/images/Menu/offerMenu/3.svg")}
                              alt="Icon"
                            />
                            Restaurant
                            <br />
                            Events
                          </Dropdown.Item>
                        </>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminreferralcode"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminreferralcode"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          All Referrals Activity Report
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/salesRepresentativedashboard"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/salesRepresentativedashboard"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Sales Representative <br /> Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/AffiliatesDashboard"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/AffiliatesDashboard"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Affiliates Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/SuperAdminPartnerDashboard"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/SuperAdminPartnerDashboard"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Partners Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/MarketingAndPromotionsDashbard"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/MarketingAndPromotionsDashbard"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Marketing & Promotions <br /> Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/SuperAdminReferralRewarddashboard"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/SuperAdminReferralRewarddashboard"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Referral Program
                          <br /> & Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/SuperAdminValidatereferralrewardprogram"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname ===
                              "/SuperAdminValidatereferralrewardprogram"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Validate Referral
                          <br /> Program Dashboard
                        </Dropdown.Item>
                      )}
                      {[1, 3, 4, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superAdminApprovedreferrals"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname &&
                            pathname === "/superAdminApprovedreferrals"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/4.svg")}
                            alt="Icon"
                          />
                          Approve Referral
                          <br /> Program Dashboard
                          <br />
                        </Dropdown.Item>
                      )}
                      {[1, 3].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/offerMenu/5.svg")}
                            alt="Icon"
                          />
                          Subscriptions
                        </Dropdown.Item>
                      )}

                      <Dropdown.Item
                        as={Link}
                        to="/superadmin/promotional-videos"
                        className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/offerMenu/5.svg")}
                          alt="Icon"
                        />
                        Promotional Videos
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/superadmin/short-videos"
                        className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                      >
                        <SVG
                          src={require("../../../assets/images/Menu/offerMenu/5.svg")}
                          alt="Icon"
                        />
                        Short Videos
                      </Dropdown.Item>
                    </DropdownButton>
                  </li>
                  <li
                    className={`${
                      (pathname && pathname === "/superadminratingreviews") ||
                      (pathname && pathname === "/superadminnomination") ||
                      (pathname && pathname === "/superadminsuggestion") ||
                      (pathname && pathname === "/superadmindonation")
                        ? "selected"
                        : ""
                    }`}
                  >
                    <DropdownButton
                      key={"right"}
                      id={`dropdown-button-drop-right`}
                      drop={"right"}
                      variant="link"
                      title={
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/review.svg")}
                          title={
                            <>
                              Others/ <br />
                              Miscellaneous
                            </>
                          }
                        />
                        // <SVG
                        //   src={require("../../../assets/images/Menu/review.svg")}
                        //   className="navigation-icon"
                        //   alt="Icon"
                        // />
                      }
                    >
                      {[1, 2, 3, 5, 6, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminratingreviews"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminratingreviews"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/1.svg")}
                            alt="Icon"
                          />
                          Ratings and
                          <br />
                          Reviews with
                          <br />
                          Likes/Comment
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 5, 7, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminnomination"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminnomination"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/2.svg")}
                            alt="Icon"
                          />
                          Nominations
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 7].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminsuggestion"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadminsuggestion"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/3.svg")}
                            alt="Icon"
                          />
                          Suggestions
                          <br />
                          and Requests
                        </Dropdown.Item>
                      )}
                      {[1, 2, 3, 10, 11, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadminnonprofitorg"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/4.svg")}
                            alt="Icon"
                          />
                          Non Profit
                          <br />
                          Organizations
                        </Dropdown.Item>
                      )}
                      {[1, 2, 5, 12].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmindonation"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadmindonation"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/5.svg")}
                            alt="Icon"
                          />
                          Donations
                        </Dropdown.Item>
                      )}
                      {[1, 13].includes(
                        this.props.auth.user.VendorUser.permission
                      ) && (
                        <Dropdown.Item
                          as={Link}
                          to="/superadmin/errorlogs"
                          className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                            pathname && pathname === "/superadmin/errorlogs"
                              ? "selected"
                              : ""
                          }`}
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/reviewMenu/5.svg")}
                            alt="Icon"
                          />
                          Error logs
                        </Dropdown.Item>
                      )}
                    </DropdownButton>
                  </li>
                  <li>
                    {[1, 3].includes(
                      this.props.auth.user.VendorUser.permission
                    ) && (
                      <DropdownButton
                        key={"right"}
                        id={`dropdown-button-drop-right`}
                        drop={"right"}
                        variant="link"
                        title={
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/settings.svg")}
                            title={<>Settings</>}
                          />
                          // <SVG
                          //   src={require("../../../assets/images/Menu/settings.svg")}
                          //   className="navigation-icon"
                          //   alt="Icon"
                          // />
                        }
                      >
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/1.svg")}
                            alt="Icon"
                          />
                          General
                          <br />
                          Settings
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/2.svg")}
                            alt="Icon"
                          />
                          Labels
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/3.svg")}
                            alt="Icon"
                          />
                          Language
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/4.svg")}
                            alt="Icon"
                          />
                          Currency
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/5.svg")}
                            alt="Icon"
                          />
                          APIs
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/6.svg")}
                            alt="Icon"
                          />
                          Map APIs
                          <br />
                          Settings
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/7.svg")}
                            alt="Icon"
                          />
                          Newsletter
                          <br />
                          Subscribers
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/Menu/settingsMenu/8.svg")}
                            alt="Icon"
                          />
                          Pages
                        </Dropdown.Item>
                      </DropdownButton>
                    )}
                  </li>
                </ul>
              </Scrollbars>
            ) : (
              <Scrollbars
                style={{
                  width: "100%",
                  height: "calc(100vh - 176px)",
                  overflowX:'hidden'
                }}
              >
                <ul type="none" className="navigation-order-list vendorMenu">
                  {(this.props?.vendorAccess?.vendor_id ||
                    this.state.vendor) && (
                    <li
                      className={`position-relative ${
                        pathname && pathname === "/notification"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <span
                        className="badge bg-danger text-white position-absolute"
                        style={{ top: -5, zIndex: 1 }}
                      >
                        {/* {totalUnreadCount} */}
                        {this.state?.notificationsCount}
                      </span>
                      <NavLink
                        exact
                        to="/notification"
                        title="Notification"
                        className="dropdown-toggle btn btn-link"
                      >
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/vendor/1.svg")}
                          title={<>Notification</>}
                        />
                      </NavLink>
                    </li>
                  )}
                  {(this.props?.vendorAccess?.screenID?.includes("ALL") ||
                    this.state.vendor) && (
                    // <li
                    //   className={`position-relative ${
                    //     // pathname && pathname === "/notification"
                    //     //   ? "selected"
                    //     //   :
                    //     ""
                    //   }`}
                    // >
                    //   <NavLink
                    //     exact
                    //     to="#"
                    //     title="Scan QR"
                    //     className="dropdown-toggle btn btn-link"
                    //   >
                    //     <IconAndTitleLeftNav
                    //       icon={require("../../../assets/images/ActionImages/image/qrcode.svg")}
                    //       title={<>Scan QR</>}
                    //     />
                    //   </NavLink>
                    // </li>
                    <QrScanGlobal />
                  )}
                  {/* require("../../../../../assets/images/ActionImages/image/qrcode.svg") */}
                  {this.state?.seatingManagementDisplay ? (
                    this.props?.vendorAccess?.vendor_id || this.state.vendor ? (
                      <li
                        className={`${
                          (pathname && pathname === "/seatingdashboard") ||
                          (pathname && pathname === "/pendingdashboard") ||
                          (pathname && pathname === "/reservationdashboard") ||
                          (pathname && pathname === "/historydashboard")
                            ? "selected"
                            : ""
                        }`}
                      >
                        <NavLink
                          exact
                          to={
                            this.state?.seatingManagementDisplay
                              ? pendingRecords.length >= 1
                                ? "/pendingdashboard"
                                : "/seatingdashboard"
                              : "/"
                          }
                          title="Seating"
                          className="dropdown-toggle btn btn-link"
                        >
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/vendor/2.svg")}
                            title={
                              <>
                                Seating <br />
                                Dashboard
                              </>
                            }
                          />
                          {/* <SVG
                          // fluid
                          src={require("../../../assets/images/Menu/vendor/2.svg")}
                          className="navigation-icon"
                          alt="seating logo"
                        /> */}
                        </NavLink>
                      </li>
                    ) : null
                  ) : null}
                  {this.state.orderingManagementDisplay ? (
                    this.props?.vendorAccess?.vendor_id || this.state.vendor ? (
                      <li
                        className={`${
                          (pathname &&
                            pathname === "/itemavailablitydashboard") ||
                          (pathname && pathname === "/categorydashboard")
                            ? "selected"
                            : ""
                        }`}
                      >
                        <NavLink
                          exact
                          to={
                            this.state?.orderingManagementDisplay
                              ? "/itemavailablitydashboard"
                              : "/"
                          }
                          title="Availability"
                          className="dropdown-toggle btn btn-link"
                        >
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/vendor/3.svg")}
                            title={
                              <>
                                Item Availability <br />
                                Dashboard
                              </>
                            }
                          />
                          {/* <SVG
                          // fluid
                          src={require("../../../assets/images/Menu/vendor/3.svg")}
                          className="navigation-icon"
                          alt="order logo"
                        /> */}
                        </NavLink>
                      </li>
                    ) : null
                  ) : null}
                  {this.state.orderingManagementDisplay ? (
                    this.props?.vendorAccess?.vendor_id || this.state.vendor ? (
                      <li
                        className={
                          (pathname && pathname === "/orderdashboard") ||
                          (pathname && pathname === "/addorder") ||
                          (pathname && pathname === "/orderrequest") ||
                          (pathname && pathname === "/orderpayment")
                            ? "selected"
                            : ""
                        }
                      >
                        <NavLink
                          exact
                          to={
                            this.state?.orderingManagementDisplay
                              ? "/orderdashboard"
                              : "/"
                          }
                          title="Ordering"
                          className="dropdown-toggle btn btn-link"
                        >
                          <IconAndTitleLeftNav
                            icon={require("../../../assets/images/Menu/vendor/4.svg")}
                            title={
                              <>
                                Ordering <br />
                                Dashboard
                              </>
                            }
                          />
                          {/* <SVG
                          // fluid
                          src={require("../../../assets/images/Menu/vendor/4.svg")}
                          className="navigation-icon"
                          alt="order logo"
                        /> */}
                        </NavLink>
                      </li>
                    ) : null
                  ) : null}
                  {this.state.experienceManagmentDisplay &&
                  (this.props?.vendorAccess?.vendor_id || this.state.vendor) ? (
                    <li
                      className={`${
                        pathname && pathname === "/experiencedashboard"
                          ? "selected"
                          : "" || pathname === "/AddExperience"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <NavLink
                        exact
                        to="/experiencedashboard/pending"
                        title="experience Dashboard"
                        className="dropdown-toggle btn btn-link"
                      >
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/leftNav/event.svg")}
                          title={<>Experience</>}
                        />
                      </NavLink>
                    </li>
                  ) : null}
                  {(this.props?.vendorAccess?.vendor_id ||
                    this.state.vendor) && (
                    <li
                      className={`${
                        pathname && pathname === "/customerbusiness"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <NavLink
                        exact
                        to="/customerbusiness"
                        title="Session Settings"
                        className="dropdown-toggle btn btn-link"
                      >
                        <IconAndTitleLeftNav
                          icon={require("../../../assets/images/Menu/admin.svg")}
                          title={
                            <>
                              Session <br />
                              Settings
                            </>
                          }
                        />
                      </NavLink>
                    </li>
                  )}
                  {/* <li
                  className={`${
                    pathname && pathname === "/mainsettlementsvendor"
                      ? "selected"
                      : "" || pathname === "/invoicereport"
                      ? "selected"
                      : "" || pathname === "/paymentactivityreports"
                      ? "selected"
                      : "" || pathname === "/scanandpayreport"
                      ? "selected"
                      : "" || pathname === "/itemreports"
                      ? "selected"
                      : "" ||
                        // || pathname === "/customerbusiness"
                        // ? "selected"
                        // : ""
                        pathname === "/allorderreport"
                      ? "selected"
                      : "" || pathname === "/orderitem-sale-and-taxreport"
                      ? "selected"
                      : "" || pathname === "/referalreport"
                      ? "selected"
                      : "" || pathname === "/Eventreports"
                      ? "selected"
                      : "" || pathname === "/offervendorreports"
                      ? "selected"
                      : "" || pathname === "/pendingseatingorder"
                      ? "selected"
                      : "" || pathname === "/allseatingreports"
                      ? "selected"
                      : ""
                  }`}
                >
                  <DropdownButton
                    key={"right"}
                    id={`dropdown-button-drop-right`}
                    drop={"right"}
                    variant="link"
                    title={
                      <SVG
                        src={require("../../../assets/images/Menu/report.svg")}
                        className="navigation-icon"
                        alt="report Icon"
                      />
                    }
                  >
                    <Dropdown.Item
                      as={Link}
                      to="/referalreport"
                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                        alt="Icon"
                      />
                      Referral
                      <br />
                      Reports
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to="/itemreports"
                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                        alt="Icon"
                      />
                      Items
                      <br />
                      Reports
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to="/Eventreports"
                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/reportMenu/2.svg")}
                        alt="Icon"
                      />
                      Event
                      <br />
                      Reports
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to="/offervendorreports"
                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                    >
                      <SVG
                        src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                        alt="Icon"
                      />
                      Offer Vendor
                      <br />
                      Reports
                    </Dropdown.Item>
                    <h6 className="ml-3">
                      <b>Seating</b>
                    </h6>
                    <div className="row">
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/pendingseatingorder"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                            alt="Icon"
                            style={{ width: "25px", height: "25px" }}
                          />
                          Seating Pending
                          <br /> Activity Report
                        </Dropdown.Item>
                      </div>
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/allseatingreports"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                            alt="Icon"
                            style={{ width: "25px", height: "25px" }}
                          />
                          All Seating
                          <br /> Report
                        </Dropdown.Item>
                      </div>
                    </div>
                    <h6 className="ml-3">
                      <b>Orders</b>
                    </h6>
                    <div className="row">
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/orderitem-sale-and-taxreport"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          Order Item <br />
                          Sales & Tax Report
                        </Dropdown.Item>
                      </div>
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/allorderreport"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/event.svg")}
                            alt="Icon"
                          />
                          All Order
                          <br /> Report
                        </Dropdown.Item>
                      </div>
                    </div>
                    <h6 className="ml-3">
                      <b>Payments & Reports</b>
                    </h6>
                    <div className="row">
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/mainsettlementsvendor"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/tag.svg")}
                            alt="Icon"
                          />
                          Settlements
                          <br /> Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/invoicereport"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/tag.svg")}
                            alt="Icon"
                          />
                          Invoice
                          <br /> Report
                        </Dropdown.Item>
                      </div>
                      <div className="col-6">
                        <Dropdown.Item
                          as={Link}
                          to="/paymentactivityreports"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/tag.svg")}
                            alt="Icon"
                          />
                          Payment Activity
                          <br /> Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="/scanandpayreport"
                          className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                        >
                          <SVG
                            src={require("../../../assets/images/leftNav/tag.svg")}
                            alt="Icon"
                          />
                          Scan & Pay
                          <br /> Report
                        </Dropdown.Item>
                      </div>
                    </div>
                  </DropdownButton>
                </li> */}
                  {(this.props?.vendorAccess?.vendor_id ||
                    this.state.vendor) && (
                    <>
                      {" "}
                      <li
                        className={`${
                          pathname && pathname === "/mainsettlementsvendor"
                            ? "selected"
                            : "" || pathname === "/invoicereport"
                            ? "selected"
                            : "" || pathname === "/paymentactivityreports"
                            ? "selected"
                            : "" || pathname === "/scanandpayreport"
                            ? "selected"
                            : "" || pathname === "/itemreports"
                            ? "selected"
                            : "" ||
                              // || pathname === "/customerbusiness"
                              // ? "selected"
                              // : ""
                              pathname === "/allorderreport"
                            ? "selected"
                            : "" || pathname === "/orderitem-sale-and-taxreport"
                            ? "selected"
                            : "" || pathname === "/referalreport"
                            ? "selected"
                            : "" || pathname === "/Eventreports"
                            ? "selected"
                            : "" || pathname === "/offervendorreports"
                            ? "selected"
                            : "" || pathname === "/pendingseatingorder"
                            ? "selected"
                            : "" || pathname === "/allseatingreports"
                            ? "selected"
                            : "" || pathname === "/offer"
                            ? "selected"
                            : "" || pathname === "/event"
                            ? "selected"
                            : "" || pathname === "/reportdashboard"
                            ? "selected"
                            : "" || pathname === "/vendorreviews"
                            ? "selected"
                            : "" || pathname === "/profile"
                            ? "selected"
                            : "" ||
                              // || pathname === "/customerbusiness"
                              // ? "selected"
                              // : ""
                              pathname === "/vendoruseropenissues"
                            ? "selected"
                            : "" || pathname === "/vendoropensuggestionissues"
                            ? "selected"
                            : ""
                        }`}
                      >
                        <DropdownButton
                          key={"right"}
                          id={`dropdown-button-drop-right`}
                          drop={"right"}
                          variant="link"
                          title={
                            <IconAndTitleLeftNav
                              icon={require("../../../assets/images/Menu/vendor/5.svg")}
                              title={<>Other</>}
                            />
                            // <SVG
                            //   src={require("../../../assets/images/Menu/vendor/5.svg")}
                            //   className="navigation-icon"
                            //   alt="Icon"
                            // />
                          }
                        >
                          {this.state?.offerManagmentDisplay ? (
                            this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor ? (
                              <Dropdown.Item
                                as={Link}
                                to={
                                  this.state?.offerManagmentDisplay
                                    ? "/offer"
                                    : "/"
                                }
                                className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                  pathname && pathname === "/offer"
                                    ? "selected"
                                    : ""
                                }`}
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/vandorGridMenu/1.svg")}
                                  alt="Icon"
                                />
                                Offers
                                <br /> Management
                              </Dropdown.Item>
                            ) : null
                          ) : null}
                          {this.state.eventManagmentDisplay ? (
                            this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor ? (
                              <Dropdown.Item
                                as={Link}
                                to={
                                  this.state?.eventManagmentDisplay
                                    ? "/event"
                                    : "/"
                                }
                                className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                  pathname && pathname === "/event"
                                    ? "selected"
                                    : ""
                                }`}
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/vandorGridMenu/2.svg")}
                                  alt="Icon"
                                />
                                Event Management
                              </Dropdown.Item>
                            ) : null
                          ) : null}

                          {this.state.experienceManagmentDisplay ? (
                            this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor ? (
                              <Dropdown.Item
                                as={Link}
                                to={
                                  this.state?.experienceManagmentDisplay
                                    ? "/specialDashboard"
                                    : "/"
                                }
                                className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                  [
                                    "/specialDashboard",
                                    "/curatedDashboard",
                                  ].includes(pathname)
                                    ? "selected"
                                    : ""
                                }`}
                              >
                                <SVG
                                  src={require("../../../assets/images/Menu/vandorGridMenu/2.svg")}
                                  alt="Icon"
                                />
                                Experience Management
                              </Dropdown.Item>
                            ) : null
                          ) : null}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/reportdashboard"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/reportdashboard"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/3.svg")}
                                alt="Icon"
                              />
                              Report <br />
                              Live Dashboard
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/vendorreviews"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/vendorreviews"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/4.svg")}
                                alt="Icon"
                              />
                              Ratings & Reviews
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/profile"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/profile"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                                alt="Icon"
                              />
                              Profile
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/customerbusiness"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/profile"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                                alt="Icon"
                              />
                              Session Settings
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/vendoruseropenissues"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/vendoruseropenissues"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/7.svg")}
                                alt="Icon"
                              />
                              Open User Tickets
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/vendoropensuggestionissues"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname &&
                                pathname === "/vendoropensuggestionissues"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/8.svg")}
                                alt="Icon"
                              />
                              Open Issues <br /> and Suggestions
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/rolemanagement"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/rolemanagement"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/9.svg")}
                                alt="Icon"
                              />
                              Roles Management
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/referrals"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/referrals"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/9.svg")}
                                alt="Icon"
                              />
                              Referrals
                            </Dropdown.Item>
                          )}

                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/staffmanagement"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/" ? "selected" : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/10.svg")}
                                alt="Icon"
                              />
                              Staff Management
                            </Dropdown.Item>
                          )}
                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <h6>
                                  <SVG
                                    src={require("../../../assets/images/leftNav/Group 52965.svg")}
                                    alt="Icon"
                                  />
                                  &nbsp;&nbsp;&nbsp; Reports
                                </h6>
                              </AccordionSummary>
                              <AccordionDetails style={{ display: "block" }}>
                                <Dropdown.Item
                                  as={Link}
                                  to="/offervendorreports"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                                    alt="Icon"
                                  />
                                  Offer
                                  <br />
                                  Reports
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/Eventreports"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/reportMenu/2.svg")}
                                    alt="Icon"
                                  />
                                  Event
                                  <br />
                                  Reports
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/itemreports"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                                    alt="Icon"
                                  />
                                  Items
                                  <br />
                                  Reports
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/categoryreports"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                                    alt="Icon"
                                  />
                                  Category
                                  <br />
                                  Reports
                                </Dropdown.Item>
                                <h6 className="ml-3">
                                  <b>Seating</b>
                                </h6>
                                <div className="row">
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/pendingseatingorder"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                        alt="Icon"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      />
                                      Seating Pending
                                      <br /> Activity Report
                                    </Dropdown.Item>
                                  </div>
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/allseatingreports"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                                        alt="Icon"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      />
                                      All Seating
                                      <br /> Report
                                    </Dropdown.Item>
                                  </div>
                                </div>

                                <h6 className="ml-3">
                                  <b>Ordering</b>
                                </h6>
                                <div className="row">
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/allorderreport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/event.svg")}
                                        alt="Icon"
                                      />
                                      All Order
                                      <br /> Report
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as={Link}
                                      to="/ordertaxreport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/event.svg")}
                                        alt="Icon"
                                      />
                                      Order Tax <br /> Report
                                    </Dropdown.Item>
                                  </div>
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/orderitem-sale-and-taxreport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/event.svg")}
                                        alt="Icon"
                                      />
                                      Order Item <br />
                                      Sales & Tax Report
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as={Link}
                                      to="/orderrefundcancellationreport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/event.svg")}
                                        alt="Icon"
                                      />
                                      Order
                                      <br /> Refund &<br /> Cancellation Report
                                    </Dropdown.Item>
                                  </div>
                                </div>
                                <h6 className="ml-3">
                                  <b>Settlements</b>
                                </h6>
                                <div className="row">
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/mainsettlementsvendor"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/tag.svg")}
                                        alt="Icon"
                                      />
                                      Settlements
                                      <br /> Report
                                    </Dropdown.Item>
                                  </div>
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/singleMerchantStatement"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/tag.svg")}
                                        alt="Icon"
                                      />
                                      Merchant Statement
                                    </Dropdown.Item>
                                  </div>
                                  <div className="col-6">
                                    <Dropdown.Item
                                      as={Link}
                                      to="/scanandpayreport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/leftNav/tag.svg")}
                                        alt="Icon"
                                      />
                                      Scan & Pay
                                      <br /> Report
                                    </Dropdown.Item>
                                  </div>
                                </div>
                                <Dropdown.Item
                                  as={Link}
                                  to="/invoicereport"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/leftNav/tag.svg")}
                                    alt="Icon"
                                  />
                                  Invoice
                                  <br /> Report
                                </Dropdown.Item>
                                <Dropdown.Item
                                  as={Link}
                                  to="/referalreport"
                                  className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                >
                                  <SVG
                                    src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                                    alt="Icon"
                                  />
                                  Referral
                                  <br />
                                  Reports
                                </Dropdown.Item>
                                {this.state.experienceManagmentDisplay &&
                                  (this.props?.vendorAccess?.vendor_id ||
                                    this.state.vendor) && (
                                    <Dropdown.Item
                                      as={Link}
                                      to="/experiencereport"
                                      className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                                    >
                                      <SVG
                                        src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                                        alt="Icon"
                                      />
                                      Experience
                                      <br />
                                      Reports
                                    </Dropdown.Item>
                                  )}
                              </AccordionDetails>
                            </Accordion>
                          )}
                          <br />
                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/paymentactivityreports"
                              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                            >
                              <SVG
                                src={require("../../../assets/images/leftNav/tag.svg")}
                                alt="Icon"
                              />
                              Payment Activity
                              <br /> Report
                            </Dropdown.Item>
                          )}
                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/memolist"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/memolist"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                                alt="Icon"
                              />
                              Memos
                            </Dropdown.Item>
                          )}
                          {(this.props?.vendorAccess?.vendor_id ||
                            this.state.vendor) && (
                            <Dropdown.Item
                              as={Link}
                              to="/earnings"
                              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                                pathname && pathname === "/earnings"
                                  ? "selected"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                                alt="Icon"
                              />
                              Earnings
                            </Dropdown.Item>
                          )}

                          {/* <Dropdown.Item
                  as={Link}
                  to="/customerbusiness"
                  className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                    pathname && pathname === "/customerbusiness"
                      ? "selected"
                      : ""
                  }`}
                >
                  <SVG
                    src={require("../../../assets/images/Menu/vandorGridMenu/6.svg")}
                    alt="Icon"
                  />
                </Dropdown.Item> */}
                        </DropdownButton>
                      </li>
                      <ChatNavigation pathname={pathname} />
                    </>
                  )}
                </ul>
              </Scrollbars>
            )}
          </div>
          <div
            className="logout-button-navigation cursor"
            onClick={this.onLogoutClick}
          >
            <IconAndTitleLeftNav
              icon={require("../../../assets/images/Menu/logout.svg")}
              title={<>Logout</>}
            />
            {/* <SVG
              src={require("../../../assets/images/Menu/logout.svg")}
              className="navigation-icon"
              alt="logout logo"
              title="Logout"
            /> */}
          </div>
        </React.Fragment>
      );
    } catch (e) {
      console.log(e);
    }
  }
}

LeftSideNavigation.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  notification: state.notifications,
  auth: state.auth,
  errors: state.errors.errors,
  allPendingDetails: state?.allDinerDetails?.vendor_all_pending_diner?.data,
  subscriptionData: state?.onboarding?.onboard_subscription_details,

  /********* Casual Dining service *********/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  casualDiningData:
    state?.onboarding?.onboard_subscription_details?.casual_dining_status,

  /********* Fast Food Dining service *********/
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  fastFoodDiningData:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining_status,

  /********* Multi Dining service *********/
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  multiDiningData:
    state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status,
  vendorAccess: state.vendorAccess,
  // &&
  // state.onboarding.onboard_subscription_details.casual_dining_status &&
  // state.onboarding.onboard_subscription_details.casual_dining_status
  //   .event_management,
});

export default connect(mapStateToProps, {
  logOutUser,
  get_all_notifications,
  get_pending_diner,
})(withRouter(LeftSideNavigation));
//28-07-2020

const OrderingReportsSuperAdmin = () => {
  try {
    return (
      <React.Fragment>
        {/* Ordering reports super admin */}
        <h6 className="ml-3">
          <b>Ordering</b>
        </h6>
        <div className="row">
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadmin/allorderactivityreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              All Orders <br />
              Activity Reports
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/superadminpendingorderactivityreport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Pending Orders
              <br /> Activity Report
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminordersummaryreport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Summary
              <br /> Report
            </Dropdown.Item>
          </div>
          <div className="col-12"></div>

          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadmin/ordertaxactivityreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Tax
              <br /> Activity Reports
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminordertaxsummaryreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Tax <br />
              Summary Reports
            </Dropdown.Item>
          </div>
          <div className="col-12"></div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminorderitemsalesreport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Item Sales
              <br /> & Tax Report
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminorderitemsalestaxsummaryreport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Item Sales
              <br /> & Tax Summary Reports
            </Dropdown.Item>
          </div>
          <div className="col-12"></div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadmin/orderrefundcancellationactivityreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Refund &<br /> Cancellation
              <br /> Activity Reports
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminorderrefundcancellationsummaryreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Order Refund & <br />
              Cancellation
              <br /> Summary Reports
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/admindeliveryreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Delivery Reports
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/admindeliverycancelledreports"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Delivery Cancellation Reports
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/admindunzotransactions"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Dunzo Transactions
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/adminposloginreport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
              Log in Report
            </Dropdown.Item>
          </div>
          <div className="col-6">
            <Dropdown.Item
              as={Link}
              to="/superadminpospriceupdatereport"
              className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
            >
              <SVG
                src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
             Price Update Report
            </Dropdown.Item>
          </div>
        </div>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};
